export default __webpack_public_path__ + "static/media/dd1ec401ef3507f6bd9a84d96783a2e41581605645409.6bc33cf6.webp";